import { Injectable } from '@angular/core';

@Injectable()
export class WillsepalocalofficesService {
  // TODO: get local offices from PSD
  localOffices = [
    'Brisbane',
    'Brendale',
    'Bundaberg',
    'Cairns',
    'Gladstone',
    'Ipswich',
    'Mackay',
    'Maryborough',
    'Mount Isa',
    'Nambour',
    'Redcliffe',
    'Rockhampton',
    'Southport',
    'Sunshine Coast',
    'Toowoomba',
    'Townsville'
  ];

  constructor() { }

  getLocalOffices () {
    return this.localOffices;
  }
}



// WEBPACK FOOTER //
// ./app/services/willsEpaLocalOffices/willsepalocaloffices.service.ts